import {recommendHttp} from './index'

function recommendRequest(url, method, data) {
    return recommendHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return recommendRequest(url, 'get', data)
}

function post(url, data) {
    return recommendRequest(url, 'post', data)
}


export function testGet() {
    return get('/mark/info')
}

export function testPost(data) {
    return post('/mark/info',data)
}

export function allStrategy() {
    return get('/recommend/strategy/all')
}
export function ruleDetail(id) {
    return get('/recommend/rule/detail?strategyId='+id)
}
export function ruleSave(data) {
    return post('/recommend/rule/save',data)
}
export function ruleDel(id) {
    return get('/recommend/rule/delete?strategyId='+id)
}
